export var PageColorTheme;
(function (PageColorTheme) {
    PageColorTheme["M2"] = "m2";
    PageColorTheme["HrBrand"] = "hr-brand";
})(PageColorTheme || (PageColorTheme = {}));
//# sourceMappingURL=page-color-theme.js.map